import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { getBookings, deleteBookings, createPayment } from "services/BookingService";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { useAuth } from "hooks/useAuth";
const paymentForm ={
  bookingId:'',
  date: '',
  paymentMode: '',
  totalAmount: '',
  remark: '',
}
const BookingsList = () => {
  const navigate = useNavigate();
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const openPaymentModal = () => setShowPaymentModal(true);
  const closePaymentModal = () => setShowPaymentModal(false);
  const [bookings, setBookings] = useState([]);
  const [booking, setBooking] = useState({});
  const [filteredBookings, setFilteredBookings] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [deleteBookingId, setDeleteBookingId] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [rooms, setRooms] = useState([]);
  const [payments, setPayments] = useState([]);
  const [totalRooms, setTotalRooms] = useState(0);
  const [loading, setLoading] = useState(false);
  const [paymentMessage, setPaymentMessage] = useState(null);
  const [paymentFormData, setPaymentFormData] = useState(paymentForm);
  const { hasPermission } = useAuth();

  useEffect(() => {
    getBookingsList();
  }, []);

  useEffect(() => {
    handleSearch();
  }, [searchQuery, bookings]);

  const getBookingsList = () => {
    getBookings().then((response) => {
      if (response && response.data.success) {
        setBookings(response.data.bookings);
        setFilteredBookings(response.data.bookings);
      }
    });
  };

  const handleSearch = () => {
    const query = searchQuery.toLowerCase();
    const filtered = bookings.filter(
      (booking) =>
        booking.companyName?.toLowerCase().includes(query) ||
        booking.agent_name?.toLowerCase().includes(query) ||
        booking.customerType?.toLowerCase().includes(query) ||
        booking.guestName?.toLowerCase().includes(query)
    );
    setFilteredBookings(filtered);
    setPage(0);
  };

  const handleChangePage = (newPage) => setPage(newPage);
  const handleRowsPerPageChange = (e) => {
    setRowsPerPage(parseInt(e.target.value, 10));
    setPage(0);
  };

  const paginatedBookings = filteredBookings.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  const handleCreate = () => {
    navigate("/add-booking", { state: { isEdit: false } });
  };

  const handleEdit = (booking) => {
    navigate("/add-booking", {
      state: { isEdit: true, editFormData: booking },
    });
  };

  const handleDelete = (id) => {
    if (window.confirm("Are you sure you want to delete this coupon?")) {
      //dispatch(deleteCouponAction(id));
    }
  };

  const exportToCSV = () => {
    const csvData = filteredBookings.map((booking) => ({
      "Booking ID": booking.name,
      "B Type": booking.customerType,
      "Comapny / Guest": booking.companyName,
      "Check In": booking.checkIn,
      "Check Out": booking.checkOut,
      "Total Cost": booking.totalCost,
      Advance: booking.totalAdvance,
    }));

    const worksheet = XLSX.utils.json_to_sheet(csvData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Bookings");

    const csvOutput = XLSX.write(workbook, {
      bookType: "csv",
      type: "array",
    });

    const blob = new Blob([csvOutput], { type: "text/csv;charset=utf-8;" });
    saveAs(blob, "bookings_list.csv");
  };

  const exportToXLS = () => {
    const xlsData = filteredBookings.map((booking) => ({
      "Booking ID": booking.name,
      "B Type": booking.customerType,
      "Comapny / Guest": booking.companyName,
      "Check In": booking.checkIn,
      "Check Out": booking.checkOut,
      "Total Cost": booking.totalCost,
      Advance: booking.totalAdvance,
    }));
    const worksheet = XLSX.utils.json_to_sheet(xlsData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Bookings");

    const xlsOutput = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const blob = new Blob([xlsOutput], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
    });

    saveAs(blob, "bookings_list.xlsx");
  };

  const showBooking = (booking) => {
    const rooms = JSON.parse(booking.rooms);
    const totalRooms = rooms.reduce(
      (sum, room) => sum + Number(room.numberOfRoom),
      0
    );
    setTotalRooms(totalRooms);
    setRooms(rooms);
    setBooking(booking);
    setPayments(booking.payments);
  };

  const deleteBooking = (id) => {
    setDeleteBookingId(id);
    setShowDeleteModal(true);
  };
  const confirmDeleteBooking = () => {
    deleteBookings(deleteBookingId).then((response) => {
      if (response && response.data.success) {
        setShowDeleteModal(false);
        getBookingsList();
      }
    });
    //setDeleteBookingId(deleteBookingId);
  };

  const handlePaymentChange = (e) => {
    const { name, value } = e.target;
    setPaymentFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handlePaymentSubmit = async (e) => {
        e.preventDefault();
        try {          
            setLoading(true);
            const payload = {
              ...paymentFormData,
              bookingId: booking.id,
            };
            const response = await createPayment(payload);    
            setLoading(false);
            if (response?.data?.success) {
              setPaymentMessage(response?.data?.message);
              getBookingsList();
              setPaymentFormData(paymentForm);
            } else if (response?.data?.errors) {
              setPaymentMessage(response?.data?.message);
            }
          
        } catch (error) {
          console.error("Error adding payment:", error);
        }
      };

  return (
    <>
      <section className="content-header">
        <div class="header-icon">
          <i class="fa fa-users"></i>
        </div>
        <div className="header-title">
          <h1>Manage Bookings</h1>
          <small>Bookings List</small>
        </div>
      </section>

      <section className="content">
        <div className="row">
          <div className="col-lg-12 pinpin">
            <div className="buttonexport" id="buttonlist">
            {hasPermission("Add Booking") && (
              <Link className="btn btn-add" to="/add-booking">
                <i className="fa fa-plus"></i> Add Booking
              </Link>
            )}
            </div>
            <div className="card lobicard mt-2" data-sortable="true">
              <div className="card-header">
                <div className="card-title custom_title">
                  <h4>Bookings List</h4>
                </div>
              </div>
              <div className="card-body">
                <div className="d-flex align-items-center mb-3">
                  <select
                    value={rowsPerPage}
                    onChange={handleRowsPerPageChange}
                    className="form-control w-auto mr-3"
                  >
                    <option value={10}>10</option>
                    <option value={25}>25</option>
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                  </select>

                  <input
                    type="text"
                    placeholder="Search by Guest name, company name, or type"
                    className="form-control w-25 mr-3"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                  />
                  <div className="btn-group ml-3">
                    <button
                      className="btn btn-exp btn-sm "
                      data-toggle="dropdown"
                    >
                      <i className="fa fa-bars"></i> Export Table Data
                    </button>
                    <ul className="dropdown-menu exp-drop" role="menu">
                      <li>
                        <a href="#" onClick={exportToCSV}>
                          <img
                            src="assets/dist/img/csv.png"
                            width="24"
                            alt="logo"
                          />{" "}
                          CSV
                        </a>
                      </li>

                      <li class="dropdown-divider"></li>
                      <li>
                        <a href="#" onClick={exportToXLS}>
                          <img
                            src="assets/dist/img/xls.png"
                            width="24"
                            alt="logo"
                          />{" "}
                          XLS
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="btn-group ml-3">
                  <button className="btn btn-add">Search</button>
                </div>

                <hr />

                <div className="table-responsive">
                  <table
                    id="dataTableExample1"
                    className="table table-bordered table-striped table-hover"
                  >
                    <thead className="back_table_color">
                      <tr class="info">
                        <th>Booking ID</th>
                        <th>B Type</th>
                        <th>Comapny / Guest </th>
                        <th>Check In</th>
                        <th>Check Out</th>
                        <th>Total Cost</th>
                        <th>Advance</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredBookings.length > 0 ? (
                        filteredBookings.map((booking) => (
                          <tr key={booking.id}>
                            <td>{booking.id} </td>
                            <td>{booking.customerType} </td>
                            <td>{booking.customerType=="B2B"?booking.agent_name:booking.companyName}</td>
                            <td>{booking.checkIn}</td>
                            <td>{booking.checkOut}</td>
                            <td>
                              <i className="fa fa-inr"></i>
                              {booking.totalCost}
                            </td>
                            <td>
                              <i className="fa fa-inr"></i>
                              {booking.totalAdvance}
                            </td>
                            <td>
                            {hasPermission("View Booking") && (
                              <button
                                title="View"
                                type="button"
                                className="btn btn-primary btn-sm"
                                data-toggle="modal"
                                data-target="#bookingInfo"
                                onClick={() => {
                                  showBooking(booking);
                                }}
                              >
                                <i className="fa fa-eye"></i>{" "}
                              </button>
                            )}
                             {hasPermission("Edit Booking") && (
                              <button
                                title="Edit"
                                type="button"
                                className="btn btn-primary btn-sm"
                                onClick={(e) => {
                                  handleEdit(booking);
                                }}
                              >
                                <i className="fa fa-pencil"></i>
                              </button>
                             )}
                              {hasPermission("Add Booking Payment") && (
                              <button
                                title="Payment"
                                type="button"
                                className="btn btn-success btn-sm"
                                data-toggle="modal"
                                data-target="#Payment"
                                onClick={()=>{openPaymentModal(); setBooking(booking)}}
                              >
                                <i className="fa fa-inr"></i>{" "}
                              </button>
                              )}
                               {hasPermission("Delete Booking") && (
                              <button
                                title="Delete"
                                type="button"
                                className="btn btn-danger btn-sm"
                                data-toggle="modal"
                                data-target="#customer2"
                                onClick={(e) => {
                                  deleteBooking(booking.id);
                                }}
                              >
                                <i className="fa fa-trash-o"></i>{" "}
                              </button>
                               )}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="8" className="text-center">
                            No bookings found.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
                {/* Pagination Controls */}
                <div className="d-flex justify-content-between align-items-center mt-3">
                  <span>
                    Showing {page * rowsPerPage + 1} to{" "}
                    {Math.min(
                      (page + 1) * rowsPerPage,
                      filteredBookings.length
                    )}{" "}
                    of {filteredBookings.length} entries
                  </span>
                  <div>
                    <button
                      className="btn btn-default btn-sm mr-2"
                      onClick={() => handleChangePage(Math.max(0, page - 1))}
                      disabled={page === 0}
                    >
                      Prev
                    </button>
                    <button
                      className="btn btn-default btn-sm"
                      onClick={() =>
                        handleChangePage(
                          Math.min(
                            Math.floor(filteredBookings.length / rowsPerPage),
                            page + 1
                          )
                        )
                      }
                      disabled={
                        (page + 1) * rowsPerPage >= filteredBookings.length
                      }
                    >
                      Next
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {showPaymentModal && (
        <div className="modal fade show d-block" tabIndex="-1" role="dialog">
          <div
            className="modal-dialog modal-lg"
            role="document"
            style={{ zIndex: "9999" }}
          >
            <div className="modal-content">
              <div className="modal-header modal-header-primary">
                <h3>
                  <i className="fa fa-inr mr-2"></i> Add Payments
                </h3>
                <button
                  type="button"
                  className="close"
                  onClick={closePaymentModal}
                >
                  &times;
                </button>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="col-md-12">
                  <form className="form-horizontal" onSubmit={handlePaymentSubmit}>
                    <div className="row">
                      <div className="col-md-6 form-group">
                        <label>Date</label>
                        <input
                          type="date"
                          name="date"
                          className="form-control"
                          value={paymentFormData.date}
                          onChange={handlePaymentChange}
                          required
                        />
                      </div>

                      <div className="col-md-6 form-group">
                        <label>Payment Mode</label>
                        <select
                          name="paymentMode"
                          className="form-control"
                          value={paymentFormData.paymentMode}
                          onChange={handlePaymentChange}
                          required
                        >
                          <option value="">Select Payment Mode</option>
                          <option value="transfer">Account Transfer</option>
                          <option value="cash">By Cash</option>
                          <option value="upi">UPI</option>
                        </select>
                      </div>

                      <div className="col-md-6 form-group">
                        <label>Total Amount</label>
                        <input
                          type="number"
                          name="totalAmount"
                          className="form-control"
                          placeholder="Enter Amount"
                          value={paymentFormData.totalAmount}
                          onChange={handlePaymentChange}
                          required
                        />
                      </div>

                      <div className="col-md-6 form-group mb-3">
                        <label>Remark</label>
                        <input
                          type="text"
                          name="remark"
                          className="form-control"
                          placeholder="Enter Remark"
                          value={paymentFormData.remark}
                          onChange={handlePaymentChange}
                          required
                        />
                      </div>
                      <div className="col-md-12 form-group mb-3">
                       <p style={{color:'green'}}>{paymentMessage}</p>
                      </div>
                      <div className="col-md-12 form-group user-form-group">
                        <div className="float-right">
                          <button type="submit" className="btn btn-success btn-sm" disabled={loading}>
                            {loading ? "Adding..." : "Add Payment"}
                          </button>                          
                        </div>
                      </div>
                    </div>
                  </form>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  className="btn btn-danger float-left"
                  onClick={closePaymentModal}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
          {/* Backdrop */}
          <div className="modal-backdrop fade show"></div>
        </div>
      )}

      <div
        className="modal fade"
        id="customer2"
        tabindex="-1"
        role="dialog"
        aria-hidden="true"
      >
        <div className="modal-dialog" style={{ zIndex: "9999" }}>
          <div className="modal-content">
            <div className="modal-header modal-header-primary">
              <h3>
                <i className="fa fa-booking m-r-5"></i> Delete Booking
              </h3>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-hidden="true"
              >
                ×
              </button>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-md-12">
                  <form className="form-horizontal">
                    <div className="row">
                      <div className="col-md-12 form-group user-form-group">
                        <label className="control-label">Delete Booking</label>
                        <div className="float-right">
                          <button
                            type="button"
                            className="btn btn-danger btn-sm"
                          >
                            NO
                          </button>
                          <button type="button" className="btn btn-add btn-sm"  data-dismiss="modal" aria-hidden="true" onClick={confirmDeleteBooking}>
                            YES
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-danger float-left"
                data-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="bookingInfo"
        tabindex="-1"
        role="dialog"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header modal-header-primary">
              <h3>
                <i className="fa fa-booking m-r-5"></i> Booking Information
              </h3>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-hidden="true"
              >
                ×
              </button>
            </div>
            <div className="modal-body">
              <table className="table px-3">
                <tbody>
                  <tr>
                    <td>
                      <p className="mb-1">
                        <strong> Booking ID</strong>
                      </p>
                      <p className="mb-0">{booking?.id}</p>
                    </td>

                    <td>
                      <p className="mb-1">
                        <strong> Total Rooms</strong>
                      </p>
                      <p className="mb-0">{totalRooms} </p>
                    </td>

                    <td colSpan={2}>
                      <p className="mb-1">
                        <strong> Sales Person</strong>
                      </p>
                      <p className="mb-0">{booking?.first_name} </p>
                    </td>
                  </tr>

                  <tr>
                    <td>
                      <p className="mb-1">
                        <strong> Customer Type </strong>
                      </p>
                      <p className="mb-0">{booking?.customerType}</p>
                    </td>

                    <td>
                      <p className="mb-1">
                        <strong> Company / Guest </strong>
                      </p>
                      <p className="mb-0">{booking.customerType=="B2B"?booking.agent_name:booking.companyName}</p>
                    </td>
                    <td colSpan={2}>
                      <p className="mb-1">
                        <strong> State</strong>
                      </p>
                      <p className="mb-0">{booking?.state}</p>
                    </td>
                  </tr>

                  <tr>
                    <td>
                      <p className="mb-1">
                        <strong> Booking Name </strong>
                      </p>
                      <p className="mb-0">{booking?.guestName}</p>
                    </td>
                    <td>
                      <p className="mb-1">
                        <strong> Check In Date </strong>
                      </p>
                      <p className="mb-0">{booking?.checkIn}</p>
                    </td>
                    <td colSpan={2}>
                      <p className="mb-1">
                        <strong> Check Out Date </strong>
                      </p>
                      <p className="mb-0">{booking?.checkOut}</p>
                    </td>
                  </tr>

                  <tr>
                   
                      <td>
                        <p className="mb-1">
                          <strong> Guest Name </strong>
                        </p>
                        <p className="mb-0">{booking?.guestName}</p>
                      </td>
                      <td>
                        <p className="mb-1">
                          <strong> Guest Phone Number </strong>
                        </p>
                        <p className="mb-0">{booking?.guestPhone}</p>
                      </td>
                      <td colSpan={2}>
                        <p className="mb-1">
                          <strong> Guest Email ID. </strong>
                        </p>
                        <p className="mb-0">{booking?.guestEmail}</p>
                      </td>
                     
                   
                  </tr>
                  {rooms.map((room) => (
                    <tr>
                      <td>
                        <p className="mb-1">
                          <strong> Room Type </strong>
                        </p>
                        <p className="mb-0">{room.roomType}</p>
                      </td>

                      <td>
                        <p className="mb-1">
                          <strong> Number Of Room </strong>
                        </p>
                        <p className="mb-0">{room.numberOfRoom}</p>
                      </td>
                    </tr>
                  ))}
                  <tr>
                    <td>
                      <p className="mb-1">
                        <strong> Number of Guest </strong>
                      </p>
                      <p className="mb-0">{booking.numberOfGuest}</p>
                    </td>

                    <td>
                      <p className="mb-1">
                        <strong> Adult Extra Mattress </strong>
                      </p>
                      <p className="mb-0">{booking.extraMattressAdult}</p>
                    </td>
                  </tr>

                  <tr>
                    <td>
                      <p className="mb-1">
                        <strong> Number of Child </strong>
                      </p>
                      <p className="mb-0">{booking.numberOfChild}</p>
                    </td>

                    <td>
                      <p className="mb-1">
                        <strong> Child Extra Mattress </strong>
                      </p>
                      <p className="mb-0">{booking.extraMattressChild}</p>
                    </td>
                  </tr>

                  <tr>
                    <td>
                      <p className="mb-1">
                        <strong> Meal Plan </strong>
                      </p>
                      <p className="mb-0">{booking?.mealPlan}</p>
                    </td>

                    <td>
                      <p className="mb-1">
                        <strong> Other Services </strong>
                      </p>
                      <p className="mb-0">{booking?.otherServices}</p>
                    </td>
                  </tr>

                  <tr>
                    <td>
                      <p className="mb-1">
                        <strong> Total Cost </strong>
                      </p>
                      <p className="mb-0">
                        <i className="fa fa-inr"></i>
                        {booking?.totalCost}
                      </p>
                    </td>

                    <td>
                      <p className="mb-1">
                        <strong> Total Advance </strong>
                      </p>
                      <p className="mb-0">
                        <i className="fa fa-inr"></i>
                        {booking?.totalAdvance}
                      </p>
                    </td>

                    <td>
                      <p className="mb-1">
                        <strong> Overdue Amount </strong>
                      </p>
                      <p className="mb-0">
                        <i className="fa fa-inr"></i>
                        {booking?.totalCost - booking?.totalAdvance}
                      </p>
                    </td>
                  </tr>

                  <tr>
                    <td colspan="3">
                      {" "}
                      <strong> PAYMENT HISTORY </strong>
                    </td>
                  </tr>
                 
                
                  { payments.map((payment)=>(
                  <tr>
                    <td>
                      <p className="mb-1">
                        <strong> Date </strong>
                      </p>
                      <p className="mb-0">{payment.date}</p>
                    </td>

                    <td>
                      <p className="mb-1">
                        <strong> Payment Mode </strong>
                      </p>
                      <p className="mb-0">{payment.paymentMode}</p>
                    </td>

                    <td>
                      <p className="mb-1">
                        <strong>Amount </strong>
                      </p>
                      <p className="mb-0">
                        <i className="fa fa-inr"></i>{payment.totalAmount}
                      </p>
                    </td>
                    <td>
                      <p>{payment.remark}</p>
                    </td>
                  </tr>
                  ))}
                </tbody>
              </table>           
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-danger float-left"
                data-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BookingsList;
